(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shogun-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    function start() {
      const bar = document.querySelector('[data-kion-lp-buy-bar]');
      if (!bar || bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const title = bar.querySelector('[data-lp-bar-title]');
      const priceGroup = bar.querySelector('[data-lp-bar-price-group]');
      const comparePrice = bar.querySelector('[data-lp-bar-compare-price]');
      const price = bar.querySelector('[data-lp-bar-price]');
      const image = bar.querySelector('[data-lp-bar-image]');
      const button = bar.querySelector('[data-lp-bar-button]');
      let box;
      let queued = false;
      let contentDirty = true;
      let entryLinksDirty = true;

      function findBox() {
        const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
        const form = forms.find(el => !el.closest('#rebuy-cart') && el.getBoundingClientRect().height > 0);
        if (!form) return null;
        return form.closest('.kion-buy-box, .home-buy-box, [data-kion-buy-box]') || form.closest('.shg-c') || form;
      }

      function syncContent() {
        const heading = box.querySelector('.product-title, [itemprop="name"], h1, h2');
        title.textContent = heading?.textContent.trim() || '';
        const sourcePrice = box.querySelector('#kion3JP1-product-display-price, [data-price-wrapper]');
        const sourceComparePrice = sourcePrice?.querySelector('s, del')?.textContent.trim() || '';
        const copy = sourcePrice?.cloneNode(true);
        copy?.querySelectorAll('s, del, .visually-hidden, .sr-only').forEach(el => el.remove());
        price.textContent = copy?.textContent.trim() || '';
        comparePrice.textContent = sourceComparePrice;
        comparePrice.hidden = !sourceComparePrice || sourceComparePrice === price.textContent;
        priceGroup.hidden = !price.textContent;
        const images = [...box.querySelectorAll('.kion3JP1-shogun-buy-box-image-image, .buy-box-image img, .product-buy-box img')];
        const sourceImage = images.find(el => el.getBoundingClientRect().width > 0) || images[0];
        const src = sourceImage?.currentSrc || sourceImage?.getAttribute('src');
        if (src && image.getAttribute('src') !== src) image.src = src;
        image.hidden = !src;
      }

      function connectEntryLinks() {
        if (!box || !document.querySelector('a[name="buy-now"], #buy-now')) return;
        const targets = new Map();
        document.querySelectorAll('.kion-lp-logo').forEach(el => targets.set(el, bar.dataset.logoLabel));
        const roots = [...document.querySelectorAll('.padding-top')].filter(el =>
          el.compareDocumentPosition(box) & Node.DOCUMENT_POSITION_FOLLOWING
        );
        const heroIndex = roots.findIndex(el => el.querySelector('h1'));
        const heroRoots = heroIndex < 0 ? [] : [roots[heroIndex]];
        const mobileHero = roots[heroIndex + 1];
        if (heroIndex >= 0 && mobileHero && !mobileHero.querySelector('h1, h2, p, button, input') && mobileHero.querySelector('.shogun-image-container')) heroRoots.push(mobileHero);
        heroRoots.forEach(root => {
          root.querySelectorAll('.shogun-image-container, .shg-box').forEach(el => {
            if (el.querySelector('h1, h2, h3, p, button, input, video, iframe')) return;
            if (el.matches('.shogun-image-container') || (!el.textContent.trim() && getComputedStyle(el).backgroundImage !== 'none')) targets.set(el, bar.dataset.heroLabel);
          });
        });
        targets.forEach((label, el) => {
          if (el.dataset.kionEntryLinked) return;
          let link = el.matches('a') ? el : el.querySelector('a');
          if (!link) {
            link = document.createElement('a');
            link.className = 'kion-lp-entry-link';
            if (getComputedStyle(el).position === 'static') el.classList.add('kion-lp-entry-position');
            el.appendChild(link);
          }
          link.setAttribute('href', '#buy-now');
          link.setAttribute('aria-label', label);
          link.setAttribute('data-kion-entry-link', label === bar.dataset.logoLabel ? 'logo' : 'hero');
          link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            scrollToBuyBox();
          });
          el.dataset.kionEntryLinked = 'true';
        });
      }

      const boxObserver = new MutationObserver(() => { contentDirty = true; schedule(); });

      function findHeroSection() {
        const root = box?.closest('.shogun-root') || document.querySelector('.shogun-root');
        if (!root) return null;
        const sections = [...root.children].filter(el => {
          const rect = el.getBoundingClientRect();
          return rect.width > 0 && rect.height >= 160 && getComputedStyle(el).position !== 'fixed';
        });
        return sections.find(el => el.querySelector('h1')) || null;
      }

      function update() {
        queued = false;
        if (!box?.isConnected || !box.getBoundingClientRect().height) {
          boxObserver.disconnect();
          box = findBox();
          if (box) {
            boxObserver.observe(box, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src'] });
            contentDirty = true;
          }
        }
        if (box && contentDirty) { syncContent(); contentDirty = false; }
        if (box && entryLinksDirty) { connectEntryLinks(); entryLinksDirty = false; }
        const cartOpen = document.querySelector('#rebuy-cart.is-visible');
        const boxRect = box?.getBoundingClientRect();
        const heroSection = box && findHeroSection();
        const heroRect = heroSection?.getBoundingClientRect();
        const desktopTriggerOffset = window.matchMedia('(min-width: 769px)').matches ? window.innerHeight * 0.25 : 0;
        const reachedTrigger = heroRect
          ? heroRect.bottom <= desktopTriggerOffset
          : !!boxRect && boxRect.bottom <= 0;
        const show = !!box && reachedTrigger && !cartOpen;
        bar.hidden = !show;
        document.body.classList.toggle('kion-lp-buy-bar-visible', show);
        if (show) document.body.style.setProperty('--kion-lp-buy-bar-height', bar.offsetHeight + 'px');
      }

      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      }

      function scrollToBuyBox() {
        if (!box?.isConnected) return;
        const target = box.querySelector('.buy-box-form') || box;
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        const headerBottom = [...document.querySelectorAll('.sticky-header, .sticky-header1')].reduce((bottom, header) => {
          const rect = header.getBoundingClientRect();
          const fixed = ['fixed', 'sticky'].includes(getComputedStyle(header).position);
          return fixed && rect.top <= 0 && rect.bottom > 0 ? Math.max(bottom, rect.bottom) : bottom;
        }, 0);
        window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerBottom - 16), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      button.addEventListener('click', scrollToBuyBox);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', () => { contentDirty = true; entryLinksDirty = true; schedule(); }, { passive: true });
      window.addEventListener('load', schedule);
      document.addEventListener('change', () => { contentDirty = true; schedule(); });
      new MutationObserver(mutations => {
        if (mutations.some(m => m.target !== bar && !bar.contains(m.target) && (m.type === 'childList' || m.target.id === 'rebuy-cart'))) { entryLinksDirty = true; schedule(); }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      schedule();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
